import { SUPPORT_MESSAGE_RECEIVED } from '../socket/constants';
import { FETCH_SUPPORT_MESSAGES, SEND_SUPPORT_MESSAGE } from './constants';

const initialState = {
  supportMessages: [],
};

const SupportReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUPPORT_MESSAGE_RECEIVED:
      return {
        ...state,
        supportMessages: [...state.supportMessages, action.payload],
      };
    case SEND_SUPPORT_MESSAGE:
      return {
        ...state,
        supportMessages: [...state.supportMessages, action.payload],
      };
    case FETCH_SUPPORT_MESSAGES:
      return {
        ...state,
        supportMessages: [...state.supportMessages, ...action.payload.data],
      };
    default:
      return state;
  }
};

export default SupportReducer;
